"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const HBIcon_1 = __importDefault(require("../components/HBIcon/HBIcon"));
function DollarList24Svg(props) {
    return react_1.default.createElement("svg", Object.assign({ xmlns: "http://www.w3.org/2000/svg", width: 24, height: 24, viewBox: "0 0 24 24" }, props),
        react_1.default.createElement("path", { fillRule: "evenodd", d: "M4 17v2H2v-2h2Zm11 0v2H6v-2h9Zm4-14a1 1 0 0 1 1 1v1.039c.944.1 1.876.384 2.596.811l.232.148-.804 1.571c-.9-.536-2.029-.868-2.928-.868-.862 0-1.493.277-1.493.98 0 1.81 5.416.831 5.397 4.398 0 1.712-1.34 2.623-2.999 2.859L20 16a1 1 0 1 1-2 0v-1.084c-1.04-.159-2.049-.54-2.801-1.12L15 13.631l.785-1.515c.88.757 2.296 1.22 3.406 1.22.938 0 1.665-.315 1.665-1.054 0-2.015-5.358-.887-5.34-4.436 0-1.55 1.085-2.41 2.484-2.716V4a1 1 0 0 1 1-1ZM4 12v2H2v-2h2Zm9 0v2H6v-2h7ZM4 7v2H2V7h2Zm9 0v2H6V7h7Z", clipRule: "evenodd" }));
}
function DollarList24(_a) {
    var { svgProps } = _a, props = __rest(_a, ["svgProps"]);
    return react_1.default.createElement(HBIcon_1.default, Object.assign({}, props),
        react_1.default.createElement(DollarList24Svg, Object.assign({}, svgProps)));
}
exports.default = DollarList24;
//# sourceMappingURL=DollarList24.js.map